import { tv } from "@ui/lib/tv";

const topBarBorder = tv({
  base: "w-full border-b border-neutral-100",
});

export interface TopBarBorderProps {
  className?: string;
}

export function TopBarBorder({ className }: TopBarBorderProps) {
  return <div className={topBarBorder({ className })} />;
}
